/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Utils } from "Utils/utils";
import makeApi, { URLS } from "Utils/apiURL";
import JumpBallLoader from "../../../Components/common/JumpBallLoader";
import "./authenticate.scss";
import { userDetail } from "Stores/userDetail";
import { observer } from "mobx-react";
import { loginValidate } from "../../../Utils/commonAPI";

const Authenticate = props => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isLoggedIn = userDetail.userInfo?.userLoggedIn;

  const authenticate = async (authCode, token) => {
    try {
      setLoading(true);
      setError(null);

      let response = await makeApi({
        url: `${URLS.authenticate}?authCode=${authCode}&token=${token}`,
        method: "GET"
      });

      if (response?.data?.success === "true") {
        await loginCheck();
      } else {
        setError(response?.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Authentication failed:", err);
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const loginCheck = async () => {
    const res = await loginValidate();
    if (res) {
      props.history.push("/dashboard");
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      props.history.push("/dashboard");
      return;
    }

    const query = Utils.getQueryParams(props.location.search);
    const authCode = query.get("auth_code");
    const token = query.get("token");

    if (authCode && token) {
      authenticate(authCode, token);
    } else {
      setLoading(false);
      setError("No auth code provided");
    }
  }, [props.location.search, props.history, isLoggedIn]);

  return (
    <div className="auth-page">
      {error ? (
        <div className="error-message">
          <h2>Authentication Failed</h2>
          <hr />
          <p>{error}</p>
        </div>
      ) : (
        <JumpBallLoader />
      )}
    </div>
  );
};

export default withRouter(observer(Authenticate));
